export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

interface Props {
    defaultFiles: DefaultFile[]
}

type DefaultFile = {
    name: string
    url: string
}

export default class extends Component<Props> {
    static template = template;
    static defaults() {
        return {
            defaultFiles: [
                {name: 'test1.jpg', url: 'http://www.example.com/test1.jpg'},
                {name: 'test2.png', url: 'http://www.example.com/test2.png'}
            ]
        } as Props;
    }
}